import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';
import company from 'assets/svg/actions/company.svg';

import TableActions from 'components/layouts/table';

import edit from 'assets/svg/actions/edit.svg';

import useDrawer from 'common/components/drawer/useDrawer';
import Form from './form';
import EnumsDropdown from '../Dropdown';

const CrewStatuses = () => {
  const [active, setActive] = useState(null);
  const [editType, setEdit] = useState(null);

  const drawer = useDrawer();

  const table = useTable({
    label: 'crew_statuses',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true
      },
      {
        header: 'Label',
        key: 'label',
        type: 'string',
        sort: true
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  return (
    <Row className="crew_statuses-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Crew Statuses"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Add Status',
              color: 'primary',
              onClick: () => {
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>

      <Col xs={12}>
        <Table
          loader
          drawer={<Form drawer={drawer} active={active} editType={editType} />}
          rows={{
            actions: () => ({
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setEdit('editIndex');
                    setActive(row);
                    drawer.open();
                  }
                },
                {
                  label: 'Edit Visibility',
                  icon: company,
                  onClick: (_, row) => {
                    setEdit('visibility');
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            })
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default CrewStatuses;
